import * as Yup from 'yup';

import { MAX_FILE_SIZE_10MB, MAX_FILE_SIZE_5MB, PHONE_REGEX } from '@/common/constants';

export const registerUserSchema = (role: string, dataDetail: any) => {
    return Yup.object({
        type: role === 'inspectingcompany' ? Yup.array()
            .of(Yup.string().oneOf(['SIRE | BIRE', 'Vetting'], 'Invalid selection for type'))
            .min(1, 'At least one type is required') : Yup.mixed().nullable(),
        companyName: Yup.string()
            .trim()
            .required('Company name is required'),
        address: Yup.string()
            .trim()
            .required('Address is required'),
        country: Yup.string()
            .trim()
            .required('Country is required'),
        contactPerson: Yup.string()
            .trim()
            .required('Contact person is required'),
        email: Yup.string()
            .trim()
            .required('Email is required')
            .email('Enter a valid email address'),
        altEmail: Yup.string()
            .trim()
            .nullable()
            .email('Enter a valid email address'),
        phone: Yup.string()
            .trim()
            .nullable()
            .matches(PHONE_REGEX, 'Phone number must contain only digits or a "+" sign')
            .max(15, 'Max length is 15 characters'),
        doc: role === 'shipoperator' && !dataDetail ? Yup.mixed()
            .test('fileSize', 'File size is too large', (value) => {
                if (!value) return true;
                return (value as File).size <= MAX_FILE_SIZE_10MB;
            }) : Yup.mixed().nullable(),
        dgt1: role === 'inspectingcompany' && !dataDetail ? Yup.mixed()
            .test('fileSize', 'File size is too large', (value) => {
                if (!value) return false;
                return (value as File).size <= MAX_FILE_SIZE_5MB;
            })
            .required('DGT-1 is required') : Yup.mixed().nullable(),
        cor: role === 'inspectingcompany' && !dataDetail ? Yup.mixed()
            .test('fileSize', 'File size is too large', (value) => {
                if (!value) return false;
                return (value as File).size <= MAX_FILE_SIZE_5MB;
            })
            .required('COR is required') : Yup.mixed().nullable(),
        companyProfile: Yup.mixed()
            .nullable()
            .test('fileSize', 'File size is too large', (value) => {
                if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                    return false;
                }
                return true;
            }),
        lapKeuAkhir: Yup.mixed()
            .nullable()
            .test('fileSize', 'File size is too large', (value) => {
                if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                    return false;
                }
                return true;
            }),
        bankDetails: Yup.mixed()
            .nullable()
            .test('fileSize', 'File size is too large', (value) => {
                if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                    return false;
                }
                return true;
            }),
        NIB: Yup.mixed()
            .nullable()
            .test('fileSize', 'File size is too large', (value) => {
                if (value && (value as File).size > MAX_FILE_SIZE_5MB) {
                    return false;
                }
                return true;
            }),
    });
};
